import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import 'moment-timezone';
import { ClinicalReviewActivityModel } from '../../../lib/models/ClinicalReviewActivityModel';
import AppealReviewActivity from './AppealReviewActivity';
import InitialReviewActivity from './InitialReviewActivity';
import { useScreenSmallerThan } from '../../../lib/hooks/breakpoint-hooks';
export type ClinicalActivityProps = {
    clinicalReviews: ClinicalReviewActivityModel[] | undefined;
};

const ClinicalReviewActivityListing = ({ clinicalReviews }: ClinicalActivityProps) => {
    const isSmallerThanSmall = useScreenSmallerThan('sm');

    return (
        <>
            {clinicalReviews !== undefined ? (
                <Box sx={boxStyle(isSmallerThanSmall)}>
                    {clinicalReviews?.length > 1 ? (
                        clinicalReviews.map((item: ClinicalReviewActivityModel, index: number) => (
                            <AppealReviewActivity
                                key={index}
                                item={item}
                                mediaSm={isSmallerThanSmall}
                            />
                        ))
                    ) : (
                        <>
                            {clinicalReviews?.map(
                                (item: ClinicalReviewActivityModel, index: number) => (
                                    <InitialReviewActivity
                                        key={index}
                                        item={item}
                                        mediaSm={isSmallerThanSmall}
                                    />
                                )
                            )}
                        </>
                    )}
                </Box>
            ) : null}
        </>
    );
};

const boxStyle: (media: boolean) => SxProps<Theme> = (media: boolean) => {
    const biggerThanSm: SxProps<Theme> = {
        padding: '0 0.625rem',
        margin: '0 1.25rem',
        background: 'white',
        borderRadius: '0.625rem 0.625rem 0 0'
    };
    const smallerThanSm: SxProps<Theme> = {
        padding: '0',
        marginBottom: '0.875rem',
        borderRadius: '0.625rem',
        background: 'white'
    };

    return media ? smallerThanSm : biggerThanSm;
};

export default ClinicalReviewActivityListing;
